import { render, staticRenderFns } from "./loanperproducts.vue?vue&type=template&id=642e45ff"
import script from "./loanperproducts.vue?vue&type=script&lang=js"
export * from "./loanperproducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports